import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./users/userSlice";
import langReducer from "./language/langSlice";

export default configureStore({
  reducer: {
    user: userReducer,
    lang: langReducer,
  },
});
